import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=5b184afe&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b184afe')) {
      api.createRecord('5b184afe', component.options)
    } else {
      api.reload('5b184afe', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=5b184afe&", function () {
      api.rerender('5b184afe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20Z88rdiB0J6i/JS/comp/ImgFallback2.vue"
export default component.exports